import { useEffect, useRef } from 'react';

const optimizeForViewport = (url) => {
  if (window.innerWidth > 768 || !url.includes('?')) return url;
  return url.replace(/w=[0-9]+/, 'w=400').replace(/q=[0-9]+/, 'q=75');
};

const useImageOptimization = (slides, currentIndex) => {
  const preloadedRef = useRef(new Set());

  useEffect(() => {
    if (!slides || slides.length < 2) return undefined;

    const nextSlide = slides[(currentIndex + 1) % slides.length];
    if (!nextSlide?.imageUrl) return undefined;

    const optimizedUrl = optimizeForViewport(nextSlide.imageUrl);
    if (preloadedRef.current.has(optimizedUrl)) return undefined;

    const preload = () => {
      const img = new Image();
      img.src = optimizedUrl;
      preloadedRef.current.add(optimizedUrl);
    };

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(preload, { timeout: 1500 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(preload, 1000);
    return () => window.clearTimeout(timeoutId);
  }, [currentIndex, slides]);

  return preloadedRef;
};

export default useImageOptimization;
